import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    pinChangeDecisionFormTitle: 'Ønsker du å bruke PIN-koden som du har på andre kort?',
    pinChangeDecisionFormTitleForNewCard: 'Ønsker du å endre PIN-kode for ditt nye kort?',
    keepPinRadioOption: 'Behold dagens PIN-kode (anbefalt)',
    changePinRadioOption: 'Endre PIN (ikke anbefalt)',
    orderNewCardSkipPin: 'Nei, gi meg PIN-kode',
    orderNewCardSelectPin: 'Velge PIN-kode selv',
    changePinAttentionMessageText1:
        'Hvis du endrer PIN-kode, vil den bli gjeldene for alle fremtidige debet- og kredittkort fra banken.',
    changePinAttentionMessageText2:
        'Eksisterende kort vil fortsatt ha den gamle PIN-koden inntil kortet blir byttet ut.',
};

export default fallbackDictionary;
